import * as React from "react";
import { Provider } from "react-redux";
import Store from "Store";
import TableComponent, { TableProps } from "./Table";

export { ColumnConfig, TableCell, TableRow } from "./Table/interfaces";

export const Table = (props: TableProps) => {
    return (
        <Provider store={Store}>
            <TableComponent {...props} />
        </Provider>
    );
};
